import { yellow } from "@mui/material/colors";
import { Box } from "@mui/system";
const NavLine = () => {
  return <Box sx={{ bgcolor: yellow[400], height: "1px", zIndex: 100 }}></Box>;
};

export default NavLine;
